import { createWizardSlice } from '../../features/Wizard/slice';

export const OrderSlice = createWizardSlice('order');
export const OrderSliceSelectors = OrderSlice.selectors;

export const OrderSliceActions = OrderSlice.actions;
export const OrderReducer = OrderSlice.reducer;
